/* eslint-disable no-unused-vars */
import React from 'react';
import './index.scss';

interface ButtonProps {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  className = '',
  onClick,
  disabled = false,
  children,
  icon,
}) => {
  return (
    <button
      className={`obro-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {icon}
    </button>
  );
};

export default Button;
